import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Heart, Users, Award, Calendar, ArrowRight } from 'lucide-react';
import { useSiteImage } from '@/contexts/SiteImagesContext';

export default function ChiSiamo() {
  const studioImg = useSiteImage('studio_about');
  const opCulturaImg = useSiteImage('operazione_cultura_link');
  return (
    <div>
      <section className="hero-wash py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F2A37] mb-4" style={{fontFamily:'Space Grotesk'}}>Chi Siamo</h1>
          <p className="text-lg text-muted-foreground max-w-3xl">Da oltre 30 anni, lo Studio Medico Boscovich è un punto di riferimento per la salute a Milano.</p>
        </div>
      </section>

      <section className="py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1F2A37] mb-6" style={{fontFamily:'Space Grotesk'}}>La Nostra Storia</h2>
              <div className="space-y-4 text-muted-foreground leading-relaxed">
                <p>Lo Studio Medico Boscovich nasce a Milano in Via Settembrini 7, con la missione di offrire servizi medici di alta qualità in un ambiente accogliente e professionale.</p>
                <p>Siamo uno Studio Medico Associato, dove lavorano diversi specialisti. Molti di loro sono ginecologi, ma nel corso degli anni abbiamo voluto offrire una gamma di servizi sempre più vasta.</p>
                <p>La nostra filosofia si basa sull&apos;ascolto del paziente, sulla competenza medica e sull&apos;utilizzo delle tecnologie più avanzate per garantire diagnosi accurate e trattamenti efficaci.</p>
              </div>
            </div>
            <div>
              {studioImg && <img src={studioImg} alt="Studio Medico Boscovich" className="rounded-2xl shadow-[var(--shadow-md)] object-cover w-full h-[350px]" />}
            </div>
          </div>
        </div>
      </section>

      <section className="section-mist py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1F2A37] mb-8 text-center" style={{fontFamily:'Space Grotesk'}}>I Nostri Valori</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: Heart, title: 'Cura del Paziente', desc: 'Ogni paziente è al centro della nostra attenzione.' },
              { icon: Award, title: 'Eccellenza Medica', desc: 'Specialisti qualificati e aggiornamento continuo.' },
              { icon: Users, title: 'Lavoro di Squadra', desc: 'Un team integrato per il benessere completo.' },
              { icon: Calendar, title: 'Accessibilità', desc: 'Prenotazioni facili e tempi di attesa ridotti.' },
            ].map(val => (
              <Card key={val.title} className="text-center"><CardContent className="p-6">
                <div className="w-12 h-12 rounded-xl bg-[hsl(var(--accent))] flex items-center justify-center mx-auto mb-4"><val.icon size={24} className="text-[#238A92]" /></div>
                <h3 className="font-semibold text-[#1F2A37] mb-2" style={{fontFamily:'Space Grotesk'}}>{val.title}</h3>
                <p className="text-sm text-muted-foreground">{val.desc}</p>
              </CardContent></Card>
            ))}
          </div>
        </div>
      </section>

      {/* Link to Operazione Cultura */}
      <section className="py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="overflow-hidden">
            <div className="grid md:grid-cols-2">
              <div className="p-8">
                <h2 className="text-2xl font-bold text-[#1F2A37] mb-4" style={{fontFamily:'Space Grotesk'}}>Operazione Cultura</h2>
                <p className="text-muted-foreground mb-4 leading-relaxed">
                  Attraverso la creatività e l&apos;immaginazione troviamo la nostra identità e la riserva interiore che stimola la guarigione. Organizziamo congressi, mostre e serate informative per i nostri pazienti.
                </p>
                <p className="text-sm text-muted-foreground mb-6">
                  Dal 2012, oltre 35 eventi tra mostre d&apos;arte, conferenze e iniziative culturali. A cura di Caterina Corni.
                </p>
                <Link to="/operazione-cultura">
                  <Button className="bg-[#238A92] hover:bg-[#0F5E66] text-white">
                    Scopri le Iniziative <ArrowRight size={16} className="ml-2" />
                  </Button>
                </Link>
              </div>
              <div className="hidden md:block">
                {opCulturaImg && <img src={opCulturaImg} alt="Operazione Cultura" className="w-full h-full object-cover" />}
              </div>
            </div>
          </Card>
        </div>
      </section>

      <section className="bg-[#238A92] text-white py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold mb-4" style={{fontFamily:'Space Grotesk'}}>Prenota il tuo appuntamento</h2>
          <p className="text-white/80 mb-6">Il nostro team di specialisti è pronto ad accoglierti</p>
          <Link to="/prenota"><Button size="lg" variant="secondary" className="bg-white text-[#238A92] hover:bg-gray-100"><Calendar size={18} className="mr-2" /> Prenota Ora</Button></Link>
        </div>
      </section>
    </div>
  );
}
